













import Vue from 'vue'
import Navigation from '@/components/common/Navigation.vue'
// import Footer from '@/components/common/Footer.vue'
import Product from '../models/Product'
import {
  ProductService,
  UserPurchaseService,
  UserProductTrackingService
} from '../services'
import { Instructor } from '../models/ProductCustomization'
import {
  extractInstructorInfoFromCustomization
  // fetchAndSaveBrandData
} from '../helper'
import { userAvatarImage } from '../helper/constants'
import LoginService from '../services/LoginService'
import { fetchCat } from '../helper/permission.helper'

export default Vue.extend({
  components: {
    Navigation
    // Footer
  },
  metaInfo() {
    const { customCss, customJs } = this.product
    const meta = {}

    if (customCss) {
      meta['style'] = [
        {
          cssText: customCss,
          type: 'text/css',
          vmid: 'product-custom-css'
        }
      ]
    }

    if (customJs) {
      meta['script'] = [
        {
          innerHTML: customJs,
          type: 'text/javascript',
          vmid: 'product-custom-js',
          body: true,
          async: true
        }
      ]
    }

    if (this.productFavicon) {
      meta['link'] = [
        { vmid: 'favicon', rel: 'shortcut icon', href: this.productFavicon }
      ]
    }

    return meta
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    disableActions(): object {
      const inPreviewMode = !!this.$route.query.builder
      return {
        pointerEvents: inPreviewMode ? 'none' : 'all'
      }
    },
    instructor(): Instructor {
      if (this.product && this.product.customizations) {
        return extractInstructorInfoFromCustomization(
          this.product.customizations
        )
      }

      return {
        heading: 'Instructor',
        name: 'Instructor',
        title: 'Instructor',
        bio: 'Lorem ipsum',
        headshot: userAvatarImage
      } as Instructor
    }
  },
  async beforeMount() {
    try {
      const productId = this.$route.params.id
      console.log('checking if product is purchased --> ', productId)
      const purchased = await UserPurchaseService.checkIfProductBought(
        productId
      )
    } catch (error) {
      this.$router.push({ name: 'library' })
    }
  },
  mounted() {
    this.loadProductData(this.productId)
    // fetchAndSaveBrandData(this)
  },
  data() {
    return {
      product: {} as Product,
      headerSection: {
        logoImage: ''
      },
      productFavicon: '',
      fetching: false,
      productStarted: false
    }
  },
  methods: {
    async loadProductData(productId: string) {
      await this.fetchProduct(this.productId)
      await this.markProductLogin(this.productId)
      this.productStarted = await this.getProductStartStatus()
    },
    async fetchProduct(productId: string) {
      this.fetching = true

      try {
        this.product = await ProductService.findById(productId)
        const customization = this.product.customizations

        if (customization && customization.favicon) {
          this.productFavicon = customization.favicon
        }

        if (customization && customization.logoImage) {
          this.headerSection.logoImage = customization.logoImage
        }
      } catch (error) {
        console.error('Error while fetching product --> ', error)
      } finally {
        this.fetching = false
      }
    },
    async markProductLogin(productId: string) {
      try {
        await UserProductTrackingService.trackProductLogin(productId)
      } catch (error) {
        console.error('Error while tracking user product login --> ', error)
      }
    },
    async getProductStartStatus(): Promise<boolean> {
      try {
        const {
          started
        } = await UserProductTrackingService.checkIfProductStarted(
          this.productId
        )
        return started
      } catch (error) {
        console.error('error while checking product started --> ', error)
        return false
      }
    }
  },
  watch: {
    productId(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.loadProductData(newValue)
      }
    }
  }
})
